class ProductCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-product-carousel-swiper')
    const scrollbarEl = this.querySelector('.js-product-carousel-scrollbar')
    const option = {
      init: false,
      spaceBetween: 10,
      slidesPerView: 1.5,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 25,
      slidesOffsetBefore: 25,
      slidesPerGroup: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      scrollbar: {
        el: scrollbarEl,
        enabled: true,
        draggable: true,
        snapOnRelease: true,
        dragSize: 'auto',
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3.4,
          spaceBetween: 15,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
        1400: {
          slidesPerView: 3.9,
          spaceBetween: 15,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
        1800: {
          slidesPerView: 4.5,
          spaceBetween: 15,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.init()
    this.$swiper.enable()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }
}

customElements.define('product-carousel', ProductCarousel)
